module.exports = __webpack_public_path__ + "img/japan-skin-connective-and-musculoskeletal-diseases-male.962115f1.png";